var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.carregado)?_c('div',{staticClass:"skin-blue"},[_c('Topo'),_c('div',{staticClass:"wrapper row-offcanvas row-offcanvas-left"},[_c('aside',{staticClass:"left-side sidebar-offcanvas"},[_c('section',{staticClass:"sidebar"},[_c('Loja'),_c('Menu')],1)]),_c('aside',{staticClass:"right-side"},[_vm._t("default")],2)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }